import { Component, OnInit, ViewChild, AfterViewInit } from "@angular/core";
import { ComponentConfig } from "../../models/component-config.interface";
import { ComponentInterface } from "../../models/component.interface";
import { ImageComponent } from "../image/image.component";
import { TextComponent } from "../text/text.component";

@Component({
  selector: "app-image-with-html",
  templateUrl: "./image-with-html.component.html",
  styleUrls: ["./image-with-html.component.css"]
})
export class ImageWithHtmlComponent
  implements ComponentInterface, OnInit, AfterViewInit {
  config: ComponentConfig;

  @ViewChild(ImageComponent)
  imageComponent: ImageComponent;

  @ViewChild(TextComponent)
  textComponent: TextComponent;

  constructor() {}

  ngOnInit() {
    if (this.imageComponent) {
      this.imageComponent.config = {
        name: "image",
        type: "image",
        imgSrc: this.config.imgSrc
      };
    }
    if (this.textComponent) {
      this.textComponent.config = {
        name: "text",
        type: "text",
        text: this.config.text
      };
    }
  }

  ngAfterViewInit() {
    this.imageComponent.config = {
      name: "image",
      type: "image",
      imgSrc: this.config.imgSrc
    };
    this.textComponent.config = {
      name: "text",
      type: "text",
      text: this.config.text
    };
  }
}



// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/components/utils/dynamic/components/image-with-html/image-with-html.component.ts